export default __webpack_public_path__ + "static/media/signupBanner.17d55808.png";